import React from 'react';

function Alert(props) {
  return (
    <svg width="10" height="11" viewBox="0 0 10 11" fill="none" {...props}>
      <path
        d="M3.77012 9.09994C3.82012 9.87994 4.46512 10.4999 5.26012 10.4999C6.05512 10.4999 6.70512 9.87994 6.75012 9.09994M8.14512 3.97994C8.14512 2.53994 7.09012 1.34994 5.71012 1.13494V0.964939C5.71012 0.749939 5.56512 0.554939 5.35512 0.509939C5.06512 0.449939 4.81512 0.669939 4.81512 0.944939V1.13494C3.43512 1.34994 2.38012 2.53994 2.38012 3.97994C2.38012 8.93994 1.00012 6.93494 1.00012 8.41494C1.00012 8.54494 1.10512 8.65494 1.24012 8.65494H9.28512C9.41512 8.65494 9.52512 8.54994 9.52512 8.41494V8.34494C9.52012 7.06994 8.14512 8.81494 8.14512 3.97994Z"
        stroke="#3E3E40"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Alert;
